module.exports = __webpack_public_path__ + "static/media/IMG-9.9a50bbf3.jpg";